<template>
  <div>
    <div id="hamburger" @click="togglemenu" class="menu-hamburger" v-if="menuOptions.loadMenu">
      <span class="mobileheadicons">
        <font-awesome-icon :icon="['fa', 'bars']" />
      </span>
    </div>
    <div
      id="mobilemenuholder"
      :class="{ 'slide-in': statusMobileMenu === 2, 'slide-out': statusMobileMenu === 1 }"
      v-if="menuOptions.loadMenu"
    >
      <div id="hamburgerclose" class="hamburger-remove" @click="togglemenu">
        <span class="mobileheadicons">
          <font-awesome-icon :icon="['fal', 'times']" />
        </span>
      </div>
      <div
        id="PEMenumobile"
        class="hideonmenu"
        style="display: block"
        v-if="menuOptions.loadMenu && wLG === false && wXL === false"
      >
        <div id="PEmobilelogobg">
          <div id="PEmobilelogo"></div>
        </div>
        <div id="PEMenulistholder">
          <div id="Mobile-PE-Menu">
            <ul class="BS-PE-navbar">
              <!-- menuitems -->
              <li v-for="(item, index) in menuitems" :key="index" :class="{ activeMobileMenu: !item.hideSub }">
                <div class="menuitemMobileMenu" @click="toggleSubmenu(index)">
                  <span class="linkMobileMenu" @click="togglemenu(null, submenuitems, item)">
                    <a
                      v-if="!MakeVueLink(item.tblMenuItemLink)"
                      :id="'ctlMenu_' + item.fixedMenuItemID"
                      :class="'BSmenulink ' + item.fixedMenuItemID + ' ' + getmenuactive(item.fixedMenuItemID)"
                      :href="item.tblMenuItemOnclickScript !== null ? '#' : item.tblMenuItemLink"
                      :target="item.tblMenuItemOnclickScript !== null ? null : item.tblMenuItemTarget"
                      :onclick="item.tblMenuItemOnclickScript"
                      @click="Startpageloading(item)"
                    >
                      <span v-html="item.menuItemName"></span>
                    </a>
                    <router-link
                      v-if="MakeVueLink(item.tblMenuItemLink)"
                      :id="'ctlMenu_' + item.fixedMenuItemID"
                      :to="item.tblMenuItemLink"
                      :class="'BSmenulink ' + item.fixedMenuItemID + ' ' + getmenuactive(item.fixedMenuItemID)"
                      @click="Startpageloading(item)"
                    >
                      <span v-html="item.menuItemName"></span>
                    </router-link>
                  </span>

                  <span class="chevMobileMenu" v-if="hasSubitem(submenuitems, item)">
                    <font-awesome-icon icon="chevron-down" />
                  </span>
                </div>
                <ul v-if="hasSubitem(submenuitems, item)" :class="{ hide: item.hideSub }" @click="togglemenu()">
                  <li
                    @click="createCookie('activeMenuID', item.fixedMenuItemID, 1)"
                    v-for="(subitem, subindex) in submenuitems.filter(
                      (si) => si.tblMenuItemParentMenuItemID === item.tblMenuItemID
                    )"
                    :key="subindex"
                  >
                    <div class="menuitemMobileMenu">
                      <router-link :to="subitem.tblMenuItemLink" v-if="MakeVueLink(subitem.tblMenuItemLink)">
                        <span v-html="subitem.menuItemName"></span>
                      </router-link>
                      <a
                        v-if="!MakeVueLink(subitem.tblMenuItemLink)"
                        :target="subitem.tblMenuItemOnclickScript !== null ? null : subitem.tblMenuItemTarget"
                        :href="subitem.tblMenuItemOnclickScript !== null ? '#' : subitem.tblMenuItemLink"
                        >
                          <span v-html="subitem.menuItemName"></span>
                        </a
                      >
                    </div>
                  </li>
                </ul>
              </li>

              <!-- profgrouplist -->
              <li :class="{ activeMobileMenu: profgroupListVisible }" v-if="profgroupList.length > 1">
                <div class="menuitemMobileMenu" @click="toggleprofgroupListVisible">
                  <span class="linkMobileMenu">
                    <a>{{ translation(14) }}</a>
                  </span>

                  <span class="chevMobileMenu">
                    <font-awesome-icon icon="chevron-down" />
                  </span>
                </div>
                <ul @click="togglemenu()">
                  <li
                    v-for="(pg, index) in profgroupList.filter((pg) => userInfo.currentProfGroup != pg.profGroupName)"
                    :key="'profgrlist' + index"
                  >
                    <div class="menuitemMobileMenu">
                      <a
                        @click="
                          toggleprofgroupListVisible()
                          changeProfGroup(pg.tblProfGroupID)
                        "
                        :key="index"
                        class="lbtWisselProfgroup"
                        >{{ pg.profGroupName }}</a
                      >
                    </div>
                  </li>
                </ul>
              </li>

              <!-- fixedlinks -->
              <XVmenuFixedlinks
                v-if="menuOptions.loadFixedLinks"
                v-bind="{ MakeVueLink, getmenuactive, hasSubitem, togglemenu }"
              ></XVmenuFixedlinks>
              <!-- taallinks -->
              <XVmenuTaalkeuze :mobile="true" v-if="menuOptions.loadLangChoice"></XVmenuTaalkeuze>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="headercontainer">
      <div id="headerrow">
        <div id="NewPEheader">
          <div id="PEleftbackgr"></div>
          <div id="PErightbackgr"></div>
          <div id="PElogo"></div>
          <div id="PEMenuContainer" v-if="menuOptions.loadMenu && (wLG === true || wXL == true)">
            <div class="hideonmenu" id="PEMenu">
              <div id="PEMenulistholder">
                <div id="BS-PE-Menu">
                  <ul class="BS-PE-navbar">
                    <li
                      v-for="(item, index) in menuitems"
                      :key="index"
                      @mouseover="showSubmenu(index)"
                      @mouseout="hideSubmenu(index)"
                      @click="createCookie('activeMenuID', item.fixedMenuItemID)"
                    >
                      <a
                        v-if="!MakeVueLink(item.tblMenuItemLink)"
                        :id="'ctlMenu_' + item.fixedMenuItemID"
                        :class="'BSmenulink ' + item.fixedMenuItemID + ' ' + getmenuactive(item.fixedMenuItemID)"
                        :href="item.tblMenuItemOnclickScript !== null ? '#' : item.tblMenuItemLink"
                        :target="item.tblMenuItemOnclickScript !== null ? null : item.tblMenuItemTarget"
                        :onclick="item.tblMenuItemOnclickScript"
                        @click="Startpageloading(item)"
                      >
                        <span v-html="item.menuItemName"></span>
                        <font-awesome-icon icon="caret-down" v-if="hasSubitem(submenuitems, item)" class="menucaret" />
                      </a>
                      <router-link
                        v-if="MakeVueLink(item.tblMenuItemLink)"
                        :to="item.tblMenuItemLink"
                        :id="'ctlMenu_' + item.fixedMenuItemID"
                        :class="'BSmenulink ' + item.fixedMenuItemID + ' ' + getmenuactive(item.fixedMenuItemID)"
                        :onclick="item.tblMenuItemOnclickScript"
                        @click="Startpageloading(item)"
                      >
                        <span v-html="item.menuItemName"></span>
                        <font-awesome-icon icon="caret-down" v-if="hasSubitem(submenuitems, item)" class="menucaret" />
                      </router-link>
                      <ul
                        v-if="hasSubitem(submenuitems, item)"
                        class="divFadeInitslow"
                        :class="{ divFadeIn: !item.hideSub, divFadeOut: item.hideSub }"
                        @click="item.hideSub = true"
                      >
                        <li
                          v-for="(subitem, subindex) in submenuitems.filter(
                            (si) => si.tblMenuItemParentMenuItemID === item.tblMenuItemID
                          )"
                          :key="subindex"
                        >
                          <a
                            @click="Startpageloading(subitem)"
                            v-if="!MakeVueLink(subitem.tblMenuItemLink)"
                            :target="subitem.tblMenuItemOnclickScript !== null ? null : subitem.tblMenuItemTarget"
                            :href="subitem.tblMenuItemOnclickScript !== null ? '#' : subitem.tblMenuItemLink"
                            >
                             <span v-html="subitem.menuItemName"></span>
                            </a
                          >
                          <router-link v-if="MakeVueLink(subitem.tblMenuItemLink)" :to="subitem.tblMenuItemLink">
                            <span v-html="subitem.menuItemName"></span>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div id="PEFixedlinks" v-if="userInfo.currentUser != undefined">
            <XVmenuTaalkeuze v-if="menuOptions.loadLangChoice"></XVmenuTaalkeuze>
            <XVmenuFixedlinks
              v-if="menuOptions.loadFixedLinks"
              v-bind="{ MakeVueLink, getmenuactive, hasSubitem, togglemenu }"
            ></XVmenuFixedlinks>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { util, FAMixin } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  name: 'XVmenu',
  props: {
    menuOptions: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters([
      'menuitems',
      'submenuitems',
      'userInfo',
      'statusMobileMenu',
      'fixedlinks',
      'profgroupListVisible',
      'profgroupList',
      'systemWarnings',
    ]),
  },
  data() {
    return {}
  },
  methods: {
    hasSubitem(submenuitems, item) {
      return submenuitems.filter((si) => si.tblMenuItemParentMenuItemID === item.tblMenuItemID).length !== 0
    },
    MakeVueLink(link) {
      return !PEGLOBALS.DotnetPage && link.indexOf('/peapp/') !== -1
    },
    ...mapMutations([
      'hideSubmenu',
      'showSubmenu',
      'toggleSubmenu',
      'setstatusMobileMenu',
      'toggleprofgroupListVisible',
      'startLoading',
    ]),
    ...mapActions(['changeProfGroup']),
    createCookie(name, value) {
      util.UsetCookie(name, value)
    },
    Startpageloading(item) {
      if (item.tblMenuItemLink !== '#' || item.tblMenuItemOnclickScript !== null) {
        if (item.tblMenuItemTarget === null) {
          this.startLoading({ showmessage: false, disablepage: false })
        }
      }
    },
    getmenuactive(name) {
      return util.UgetCookie('activeMenuID') === name ? 'activeMenuItem' : ''
    },
    async togglemenu(e, submenuitems, item) {
      await this.$nextTick()
      if (submenuitems && this.hasSubitem(submenuitems, item)) {
        return false
      }
      this.setstatusMobileMenu(this.statusMobileMenu)
      return true
    },
  },
  mounted() {},
}
</script>

